export default __webpack_public_path__ + "static/2020-3-7c5ffdad4d934c42d9949cecd706fa06.jpg";